import {useEffect} from "react";
import Whitepaper from '../components/papers/whitepaper-panel';
import FAQ from "../components/papers/FAQ-panel";
import FeaturesAndMarketplaces from "../components/papers/features-and-marketplaces";
import {gPageView} from "../google-analytics";
import Partners from "../components/papers/partners";

function PapersPage() {
    useEffect(() => {
        gPageView('papers');
    }, );
    return (
        <a id="papers-page">
            <div className="panel">
                <Whitepaper />
                <FAQ />
                <Partners />
                <FeaturesAndMarketplaces />
            </div>
        </a>
    );
}

export default PapersPage;